module.exports = __webpack_public_path__ + "img/6775d93289d3af62be13a1e716646044.png";